import React from 'react';

import { AgreementTermsLink } from 'app/constants/links';

export const PoliticsOfConfindential = () => (
    <div className="PoliticsOfConfidential">
        Нажимая Подтвердить, вы соглашаетесь с{' '}
        <AgreementTermsLink title="Политикой конфиденциальности" /> и даёте
        согласие на сбор, хранение и обработку персональных данных
    </div>
);
